import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'state/store';

import { patchResponseForId } from 'services/responses';

import { SaveResponseProps } from './useSaveResponse';

/**
 * PATCH with `awaitSync=true`
 */
export function useSaveResponseSynchronously() {
  const { responseId } = useSelector((state: RootState) => state.application.activeResponse);

  const [isSyncing, setIsSyncing] = useState(false);
  const [syncError, setSyncError] = useState<Error | null>(null);

  const patchSynchronously = useCallback(
    async (responseData: SaveResponseProps) => {
      if (!responseId) throw new Error('Missing application response id');

      setIsSyncing(true);
      setSyncError(null);
      try {
        await patchResponseForId({
          responseId,
          responseData,
          awaitSync: true,
        });
        setIsSyncing(false);
      } catch (e) {
        const err = e instanceof Error ? e : new Error(String(e));
        setSyncError(err);
        throw err;
      } finally {
        setIsSyncing(false);
      }
    },
    [responseId],
  );

  return { patchSynchronously, isSyncing, syncError };
}
